import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'
import { TooltipWrapper } from './tooltip-wrapper'
import { Button } from './button'

/**
 * Icon-only in the table toolbar, where space is tight and the row of controls
 * reads better as glyphs. The label comes back below `md`, where these same
 * controls are stacked in the "Table options" sheet and need naming.
 */
export function ExportButton({ onClick, disable }: { onClick: () => void; disable: boolean }) {
  return (
    <TooltipWrapper message="Export" placement="bottom">
      <Button variant="white" size="sm" className="md:px-2" aria-label="Export" onClick={onClick} disabled={disable}>
        <ArrowDownTrayIcon className="h-4 w-4" />
        <span className="text-ui-xs md:hidden">Export</span>
      </Button>
    </TooltipWrapper>
  )
}
